import React, { Component } from 'react';
import config from 'react-global-configuration';
import RequestApi from '../../Miscelania/RequestApi';
import { Link } from 'react-router-dom';


// Helpers de formulário
import InputMask from 'react-input-mask';
import Select from 'react-select';
// Importação da tabela
import { BootstrapTable, TableHeaderColumn } from 'react-bootstrap-table';

import TrainingStaffDate from './TrainingStaffDate';
import getLocale from '../../../i18n/getLocale';

class TrainingConfirmationsTab extends Component {
  constructor(props) {
    super(props);

    this.state = {
      overlay: {
        message: '',
        type: '',
        status: 'closed',        
      },
      redirect_url: false,
      loaded: 0,
      training_id: this.props.training_id,
      confirmations: [],
    };

    this.locale = getLocale();

    //bind específico
    this.ConfirmPresence = this.ConfirmPresence.bind(this);
    this.ConfirmAbsence = this.ConfirmAbsence.bind(this);
    this.ConfirmAll = this.ConfirmAll.bind(this);
  }

  // Handlers
  handleChange (name, event) {
    var change = {};
    change[name] = event.target.value;
    this.setState(change);
  } 
  handleSelectChange(name, event) {
    var change = {};
    if(event == null) {
      change[name] = null;
    } else {
      change[name] = event.value;
    }
    this.setState(change);
  }

  // LM
  componentWillReceiveProps(newProps) {
    this.setState({
      verify_confirmations: newProps.verify_confirmations,
    });
    if((this.state.loaded === 0 && Array.isArray(newProps.confirmations)) || (this.state.loaded === 1 && newProps.updated === 1)){
      this.setState({
        training_id: newProps.training_id,
        confirmations: newProps.confirmations,
        verify_confirmations: newProps.verify_confirmations,
        loaded: 1,
      });
    }
  }

  

  ConfirmAll (event) {
    var id = event.currentTarget.value;
    var confirm = window.confirm(this.locale.Treinamentos.EditarTreinamento.tabPresenca.confirmarTodasAsPresencas);
    if (confirm) {
      this.props.handleAlert('', '', 'open');
      var datasave = {
        id: this.state.training_id,
      };
      var header = this.refs.request_api.header('application/json');
      var self = this;
      Promise.resolve(header).then(function(value) {
        fetch(config.get('api') + '/treinamento/confirmar/todas', { method: 'PUT', mode: 'cors', headers: value, body: JSON.stringify(datasave) }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
          self.refs.request_api.validate(responseJson, 'alert');
          if (responseJson.status === 'success') {
            self.props.updateData(responseJson);
          } else {
            self.props.handleAlert(responseJson.message, responseJson.status, 'open');
          }
        }).catch((error) => {
          console.error(error);
        });
      });
    }
  }

  ConfirmPresence (event) {
    var id = event.currentTarget.value;
    var confirm = window.confirm(this.locale.Treinamentos.EditarTreinamento.tabPresenca.confirmarPresencaDesseAluno);
    if (confirm) {
      this.props.handleAlert('', '', 'open');
      var datasave = {
        id: id,
      };
      var header = this.refs.request_api.header('application/json');
      var self = this;
      Promise.resolve(header).then(function(value) {
        fetch(config.get('api') + '/treinamento/confirmar/presenca', { method: 'PUT', mode: 'cors', headers: value, body: JSON.stringify(datasave) }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
          self.refs.request_api.validate(responseJson, 'alert');
          if (responseJson.status === 'success') {
            self.props.updateData(responseJson);
          } else {
            self.props.handleAlert(responseJson.message, responseJson.status, 'open');
          }
        }).catch((error) => {
          console.error(error);
        });
      });
    }
  }
  ConfirmAbsence (event) {
    var id = event.currentTarget.value;
    var confirm = window.confirm(this.locale.Treinamentos.EditarTreinamento.tabPresenca.confirmarAusenciaDesseAluno);
    if (confirm) {
      this.props.handleAlert('', '', 'open');
      var datasave = {
        id: id,
      };
      var header = this.refs.request_api.header('application/json');
      var self = this;
      Promise.resolve(header).then(function(value) {
        fetch(config.get('api') + '/treinamento/confirmar/ausencia', { method: 'PUT', mode: 'cors', headers: value, body: JSON.stringify(datasave) }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
          self.refs.request_api.validate(responseJson, 'alert');
          if (responseJson.status === 'success') {
            self.props.updateData(responseJson);
          } else {
            self.props.handleAlert(responseJson.message, responseJson.status, 'open');
          }
        }).catch((error) => {
          console.error(error);
        });
      });
    }
  }

  render() {
    var self = this;
    return (
<div>
  <RequestApi ref={'request_api'} />
  <h3 className="page-title">{this.locale.Treinamentos.EditarTreinamento.tabPresenca.tituloListaDePresenca}</h3>
  <hr/>
  {(self.state.verify_confirmations === 1) ?  
    <button className="btn btn-lg btn-block btn-success" onClick={self.ConfirmAll}><i className="fa fa-check"></i> {this.locale.Treinamentos.EditarTreinamento.tabPresenca.botaoConfirmarTodasAsPresencas}</button>
    :
    ""
  }
  <hr/>
  {(this.state.confirmations === null || typeof this.state.confirmations === 'undefined') ?  <div><small><em>{this.locale.Treinamentos.EditarTreinamento.tabPresenca.nenhumAlunoCadastrado}</em></small><hr/></div> 
  : 
  <div>
    <table className="table table-bordered table-stripped table-hover">
      <thead>
        <tr>
          <th className="col-md-9 text-center">{this.locale.Treinamentos.EditarTreinamento.tabPresenca.tabela.Funcionario}</th>
          <th className="col-md-3 text-center">{this.locale.Treinamentos.EditarTreinamento.tabPresenca.tabela.PresencaAusencia}</th>
        </tr>
      </thead>
      <tbody id="suppliers-certifications">
        {Object.keys(self.state.confirmations).map(function(k) {
          return (
            <tr>
              <td className="text-center">{self.state.confirmations[k].staff.name}</td>
              <td className="text-center">
                {(self.state.confirmations[k].attendance == 1) ?  
                  <p className="text-success"><i className="fa fa-fw fa-check"></i> {self.locale.Treinamentos.EditarTreinamento.tabPresenca.tabela.PresencaConfirmada}</p>
                  : (self.state.confirmations[k].attendance == 0) ?
                  <p className="text-warning"><i className="fa fa-fw fa-check"></i> {self.locale.Treinamentos.EditarTreinamento.tabPresenca.tabela.AusenciaConfirmada}</p>
                  :
                  <div className="btn-group">
                    <button className="btn btn-block btn-lg btn-success" value={self.state.confirmations[k].id} onClick={self.ConfirmPresence}><i className="fa fa-fw fa-check"></i> {self.locale.Treinamentos.EditarTreinamento.tabPresenca.tabela.ConfirmarPresenca}</button>
                    <button className="btn btn-block btn-lg btn-warning" value={self.state.confirmations[k].id} onClick={self.ConfirmAbsence}><i className="fa fa-fw fa-check"></i> {self.locale.Treinamentos.EditarTreinamento.tabPresenca.tabela.ConfirmarAusencia}</button>
                  </div>
                }
              </td>
            </tr>
          );
        })}
      </tbody>
    </table>
    <hr/>
  </div>
  }
</div>
    );
  }
}

export default TrainingConfirmationsTab;



// WEBPACK FOOTER //
// ./src/Components/Trainings/Elements/TrainingConfirmationsTab.js